module.exports = __webpack_public_path__ + "static/media/logo-sacem.41a0d633.jpg";